<template>
  <div class="crtvup-text-book-reader" :class="[
    !showNavbar ? 'do-not-display-nav-bar' : '',
    'crtvup-text-book-reader-' + pageType,
  ]">
    <xml-digital-teaching v-if="digitalTeaching" ref="xmlDigitalTeaching" :textBookData="textBookData" :catalogList="catalogList"
      :looseLeafData="looseLeafData" :bookGraphData="bookGraphData" :bookGraphIndexs="bookGraphIndexs"
      :location="location" :notesList="makData.note.list" :bookmarkList="makData.bookmark.list"
      :highlightList="makData.highlight.list" :linkList="makData.lineation.list" :tableList="tableList"
      :continueReading="continueReading" :isTrial="isTrial" :isTrialIndex="isTrialIndex" :testPaperPath="testURL"
      userType="student" :isOpenPaper="false" @updateReadLocation="updateReadLocation" @addNote="confirm"
      @editNote="updateNotes" @deleteNote="deleteNotes" @addBookmark="addBookmark" @deleteBookmark="deleteBookmark"
      @addHighlight="addHighlight" @deleteHighlight="deleteHighlight" @addLink="addLink" @deleteLink="deleteLink"
      @downloadFile="downloadFile" @openTestPaper="openTestPaper" :basisPath="basisPath" :pageType="pageType"
      :trialText="trialText" :trialPrompt="trialPrompt" :isShowAi="textBookData.showAi" :isOpenHyperlink="true"
      :catalogLevel="6" :showoQuestionBank="showoQuestionBank" loadingMode="roll" :progressData="progressData"
      @setanalysis="setanalysis" systemEnvId="d58a0f05-b562-46fc-9516-55be91e21655"
      looseleafUrl="https://looseleaf-v2.ysy.crtvup.com.cn/" :userInputRecord="userInputRecord"
      @openQuestionBank="openQuestionBank" @openAiParsing="openAiParsing" @openStudyPlan="$refs.studyPlan.open()"
      @submitTheInputContent="submitTable" @deleteTheInputContent="deleteTableItem" :generalAPI="{}"/>
    <xml-robot ref="xmlRobot" :bookName="textBookData.textBooksName" :goodsId="goodsId" :aiInfo="aiInfo"
      v-if="textBookData.showAi == '0' && pageType != 'pc'" />
    <robot ref="robot" :bookName="textBookData.textBooksName" :goodsId="goodsId" :aiInfo="aiInfo"
      v-if="textBookData.showAi == '0' && pageType == 'pc'" />

    <iframe v-if="src" :src="src" frameborder="0" class="iframe" id="iframe"></iframe>
    <el-dialog width="90%" :visible.sync="showXmlDialog" top="20px" center>
      <!-- <div @click="$router.back()" class="el-dialog-icon-arrow-left"><i class="el-icon-arrow-left"></i></div> -->
      <iframe width="100%" :height="iframeHeight" :src="iframeSrc" frameborder="0">

      </iframe>
    </el-dialog>
    <StudyPlan ref="studyPlan" :dataList="catalogList" />
  </div>
</template>

<script>
import xmlRobot from "@/components/xmlRobot/xmlRobot";
import robot from "@/components/robot.vue";
import {
  getTextBookInfo,
  getTextBookCatalog,
  getTextBookLooseLeaf,
  getLeaf,
  getGraphAnchorIndexList,
} from "@/api/looseleaf/looseleaf";
import { getCatalogInfoById } from "@/api/mobileterminalread/index";
import {
  insertNote,
  update,
  selectNoteListByFileId,
  removeNoteById,
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
  selectReadInfo, //获取阅读时长
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  updateOcReadSchedule, //更新阅读进度
} from "@/api/special/special";
import {
  getLearningRecord,
} from "@/api/user/order";
import { testURL } from "@/utils/config";
import { getToken, setToken } from "@/utils/auth";
import { createPreviewSrc } from "@/api/looseleaf/looseleaf";
import { looseleafGetToken } from "@/api/index/index";
import { getBookGraphs } from "@/api/jiurui";
import {
  goodsInfoDetail,
  isHavingPermissions,
} from "@/api/bookstore/bookstore";
import "echarts/theme/macarons";
import StudyPlan from "./components/plan.vue";
import { mapGetters } from "vuex";
export default {
  components: { xmlRobot, robot, StudyPlan },
  data() {
    return {
      digitalTeaching: false,
      goodsId: "",
      textBookData: {},
      catalogList: [],
      looseLeafData: {},
      bookGraphData: {},
      bookGraphIndexs: [],
      trialText: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      trialPrompt: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      location: "",
      continueReading: false,
      basisPath: "",
      notesList: [],
      bookmarkList: [],
      pageType: "pc",
      contentList: [],
      isTrial: false,
      isTrialIndex: 10,
      textBookId: "",
      isShow: "",
      showRobot: true,
      testURL: testURL,
      showNavbar: true,
      TimeParameter: null,
      operationalState: 0,
      aiInfo: {},
      src: "",
      robotBook: {
        "1694952726309507072": {
          name: "三秦文化概论",
        },
        "1674758026424356864": {
          name: "药事管理与法规（第2版）",
        },
        "1686915284222480384": {
          name: "建筑构造",
        },
        "1613418196050776064": {
          name: "药事管理与法规",
        },
        "1669152756075728896": {
          name: "建筑构造（第3版）",
        },
        "1737393327818543104": {
          name: "建筑工程质量检验案例分析",
        },
      },
      makData: {
        note: {
          list: [],
        },
        bookmark: {
          list: [],
        },
        highlight: {
          list: [],
        },
        lineation: {
          list: [],
        },
      },
      setInterval2: null,
      showoQuestionBank: false,
      goodsInfo: {},
      showXmlDialog: false,
      iframeSrc: "",
      tableList: [],
      userInputRecord: {
        getTableData: e => this.getTableData(e),
      },
      progressData: {
        studentName: '',
        readingDays: 0,
        readingTime: 0,
        progress: 0
      }
    };
  },
  provide() {
    return {
      getXmlShadowingConfig: () => ({
        APPID: '98fcf4d6',//
        API_SECRET: 'Y2FkN2Y1MGZjN2U0M2I1MTU4Y2FlZjA0',
        API_KEY: 'b7e405d6af09050e4a6976f31ec37640'
      }),
    }
  },
  computed: {
    ...mapGetters(["name"]),
    iframeHeight() {
      return window.innerHeight - 150 + "px";
    },
  },
  created() {
    // localStorage.clear();
    let router = this.$route.query;
    let version = router.source;
    this.goodsId = router.goodsId || "";
    this.continueReading = router.continueReading == "true" ? true : false;
    this.isTrial = router.isTrial == "true" ? true : false;
    getLearningRecord().then((res) => {
      let data = res.data || {}
      this.progressData.readingTime = data.hour * 60
      this.progressData.readingDays = data.studyNum
    })
    // if (router.textBookId != '1902590675968430080') {
    //   // localStorage.clear();
    //   const allKeys = Object.keys(localStorage);

    //   allKeys.forEach(key => {
    //     if (key.indexOf('simulated-data-table_') === -1) {
    //       localStorage.removeItem(key);
    //     }
    //   });
    // }
    if (this.$route.query.ysyWebToken) {
      console.log(this.$route.query.ysyWebToken);
      setToken(this.$route.query.ysyWebToken);
    }
    // this.getTextBookDetail(router,version)
    goodsInfoDetail(this.goodsId).then((response) => {
      this.goodsInfo = response.data || {};
      let xiaoZhi = this.goodsInfo.xiaoZhi || {};
      this.aiInfo={
        ...xiaoZhi,
        bookAiId:this.goodsInfo.goods.bookAiId,
      }
      if (this.goodsInfo.goods?.questionBankId) {
        this.showoQuestionBank = true;
      } else {
        this.showoQuestionBank = false;
      }
      if (this.goodsInfo?.sourceList[0]?.sourceType == "V3") {
        version = 'v3'
      }

      this.getTextBookDetail(router, version);
    });
  },

  mounted() {
    let router = this.$route.query;
    if (router.pageType) {
      this.pageType = router.pageType;
    }
    const hasToken = getToken();
    if (this.pageType == 'pc' && !hasToken) {
      this.$router.push({
        path: "/login",
      });
    }
    this.getTableList()

  },
  methods: {
    getTextBookDetail(router, version) {
      // goodsInfoDetail(this.goodsId).then((response) => {
      // this.goodsInfo = response.data || {};
      // if (this.goodsInfo.goods.questionBankId) {
      //   this.showoQuestionBank = true;
      // } else {
      //   this.showoQuestionBank = false;
      // }
      // version = this.goodsInfo?.sourceList[0]?.sourceType == "V3" ? "v3" : "";
      isHavingPermissions({
        fileType: this.goodsInfo.sourceList[0].fileType,
        goodsFileId: this.goodsInfo.sourceList[0].filesId,
        goodsId: router.goodsId || "",
        relevanceId: router.relevanceId || "",
        resource: router.resource || "",
        resourceType: router.resourceType || "",
        teachInstId: router.teachInstId || "",
      }).then((pers) => {
        if (pers.data.hasPermission == true) {
          this.isTrial = false;
        } else {
          this.isTrial = true;
        }
      });
      this.progressData.studentName = this.name

      if (this.$route.query.ysyWebToken) {
        console.log(this.$route.query.ysyWebToken);
        setToken(this.$route.query.ysyWebToken);
        setTimeout(() => {
          console.log("getToken", getToken());
          if (this.textBookId == "1655372241083891712") {
            looseleafGetToken().then((res) => {
              let data = {
                token: getToken(),
                pageType: this.pageType,
                businessType: router.businessType,
                looseLeafId: "",
                textBookId: "",
                isTrial: this.isTrial,
              };
              if (router.businessType == "textBook") {
                data.textBookId = this.textBookId;
              } else {
                data.looseLeafId = this.catalogId;
              }
              createPreviewSrc(data).then((res) => {
                if (res.code == 200) {
                  this.src = res.data;
                }
              });
            });
          }
          this.getData("note");
          this.getData("bookmark");
          this.getData("highlight");
          this.getData("lineation");
          this.getFileLocation();
          this.selectTimeParameter();
        }, 1000);
      } else if (getToken()) {
        this.getData("note");
        this.getData("bookmark");
        this.getData("highlight");
        this.getData("lineation");
        this.getFileLocation();
        this.selectTimeParameter();
      }

      if (router.textBookId) {
        this.textBookId = router.textBookId;
      }
      this.showNavbar = router.showNavbar == "0" ? false : true;

      if (router.catalogId) {
        this.catalogId = router.catalogId;
        getCatalogInfoById({ catalogId: router.catalogId, type: version }).then(
          (res) => {
            this.queryData(res.data);
          }
        );
      } else if (
        router.businessType == "textBook" &&
        this.textBookId != "1655372241083891712"
      ) {
        getTextBookInfo(this.textBookId, version).then((textBook) => {
          this.textBookData = textBook.data;
          this.getGraphData();
          getTextBookCatalog(
            this.textBookId,
            "1",
            this.textBookData.overallStatus == 'already' ? this.textBookData.publishVersionId : this.textBookData.editVersionId,
            version
          ).then((catalog) => {
            this.catalogList = catalog.data;
          });
          getTextBookLooseLeaf(
            this.textBookId,
            this.textBookData.overallStatus == 'already' ? this.textBookData.publishVersionId : this.textBookData.editVersionId,
            version
          ).then((looseLeaf) => {
            this.looseLeafData = JSON.parse(looseLeaf.msg);
            setTimeout(() => {
              this.digitalTeaching = true;
            }, 500);
          });
          if (this.goodsInfo.xiaoZhi) {
            this.textBookData.showAi = '0'
          }
          this.$emit("getbookinfo", this.textBookData);
        });
      } else if (router.businessType == "looseLeaf") {
        getLeaf(this.textBookId, version).then((res) => {
          this.textBookData = res.data;
          this.catalogList = [
            {
              children: [],
              hiddenFlag: "0",
              id: this.textBookId,
              label: res.data.looseLeafName,
              level: null,
              orderNum: 0,
              parentId: null,
              uploadFileUrl: "",
            },
          ];

          let looseLeafData = {};
          looseLeafData[this.textBookId] = res.data;

          this.looseLeafData = {
            ...looseLeafData,
          };
          setTimeout(() => {
            this.digitalTeaching = true;
          }, 500);
        });
      }
      // });
    },
    openQuestionBank() {
      if (this.pageType == "pc") {
        const { href } = this.$router.resolve({
          path: "/bookstore/generateQuestion",
          query: {
            goodsId: this.goodsInfo.goods.questionBankId,
            resourceType: "goods",
            resource: "bookCity",
            relevanceId: this.goodsInfo.goods.questionBankId,
            bookName: this.goodsInfo.goods.questionBankName,
            showAi: true,
            minWin: "1"
          },
        });
        // window.open(href, "_blank");

        // this.iframeSrc = "/" + href;
        this.iframeSrc = href;
        this.showXmlDialog = true;
      } else {
        this.myUni.postMessage({
          data: {
            name: "openQuestionBank",
            value: {
              goodsId: this.goodsInfo.goods.questionBankId,
              resourceType: "goods",
              resource: "bookCity",
              relevanceId: this.goodsInfo.goods.questionBankId,
              bookName: this.goodsInfo.goods.questionBankName,
            },
          },
        });
      }
    },

    getGraphData() {
      if (this.textBookData.courseCode) {
        getBookGraphs({
          courseCode: this.textBookData.courseCode,
        }).then((res) => {
          this.bookGraphData = res.data;
        });
      }
      // getGraphAnchorIndexList({
      //   courseCode: this.textBookData.courseCode,
      // }).then(res => {
      //   this.bookGraphIndexs = res.rows || []
      // })
    },
    // 确认添加笔记
    confirm(e) {
      this.addData("note", e);
    },

    // 更新笔记
    updateNotes(e) {
      this.updateData("note", e);
    },
    // 删除笔记
    deleteNotes(e) {
      this.deleteData("note", e);
    },
    // 添加书签
    addBookmark(e) {
      this.addData("bookmark", e);
    },

    // 删除书签
    deleteBookmark(e) {
      this.deleteData("bookmark", e);
    },

    // 高亮操作
    addHighlight(model, rollback) {
      this.addData("highlight", model);
    },
    // 高亮删除
    deleteHighlight(model, rollback) {
      this.deleteData("highlight", model);
    },
    // 划线操作
    addLink(model, rollback) {
      this.addData("lineation", model);
    },
    // 划线删除
    deleteLink(model, rollback) {
      this.deleteData("lineation", model);
    },

    submitTable(e) {

      this.tableList.unshift({
        ...e,
        type: 'table',
        // 时间
        createTime: new Date()
      })
      let list = JSON.stringify(this.tableList)
      localStorage.setItem('simulated-data-table_' + this.goodsId, list)
      this.$refs.xmlDigitalTeaching.showToast("提交成功", "success");
      this.getTableList()
    },
    getTableList(e) {
      this.tableList = JSON.parse(localStorage.getItem('simulated-data-table_' + this.goodsId)) || []

    },

    deleteTableItem(item) {
      let i = this.tableList.findIndex(items => items.id == item.id)
      this.tableList.splice(i, 1)
      let list = JSON.stringify(this.tableList)
      localStorage.setItem('simulated-data-table_' + this.goodsId, list)
      this.getTableList()
    },

    getTableData(e) {
      return new Promise((resolve, reject) => {
        let list = JSON.parse(localStorage.getItem('simulated-data-table_' + this.goodsId)) || []
        let tableList = list.filter(item => item.location == e.location)

        resolve({ table: tableList[0], fillInTheNumber: tableList.length })
      })
    },

    addData(type, item) {
      let data = {
        goodsId: this.goodsId,
        goodsFileId: this.goodsId,
        originalText: item.selectionText,
        textRange: JSON.stringify(item),
        href: item.location,
        noteContent: item.noteContent,
        type: type,
      };

      insertNote(data).then(() => {
        this.$refs.xmlDigitalTeaching.showToast("添加成功", "success");
        this.getData(type, item);
      });
    },
    getData(type, item) {
      selectNoteListByFileId(this.goodsId, type).then((res) => {
        let list = res.data || [];
        this.makData[type].list = list.map((item, index) => {
          // this.makData[type].list.push(JSON.parse(item.textRange))
          return Object.assign(
            {},
            { ...JSON.parse(item.textRange), makId: item.id }
          );
        });
      });
    },
    // 更新数据
    updateData(type, item) {
      let data = {
        id: item.makId,
        goodsId: this.goodsId,
        goodsFileId: this.goodsId,
        originalText: item.selectionText,
        textRange: JSON.stringify(item),
        href: item.location,
        noteContent: item.noteContent,
        type: type,
      };
      update(data).then((response) => {
        if (response.code == 200) {
          this.$refs.xmlDigitalTeaching.showToast("修改成功", "success");
          this.getData(type, item);
        }
      });
    },

    // 删除数据
    deleteData(type, item) {
      removeNoteById(item.makId).then((response) => {
        this.$refs.xmlDigitalTeaching.showToast("删除成功", "success");
        this.getData(type, item);
      });
    },

    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;

        this.setInterval2 = setInterval(() => {
          this.operationalState++;
          if (this.operationalState < 60) {
            this.updateOcDownloadReading(); //更新阅读时长
          }
        }, this.TimeParameter * 60000);
      });
    },

    // 更新阅读进度
    updateOcReadSchedule(data) {
      updateOcReadSchedule({
        fileId: this.goodsId,
        readingLocation: data.location + '__' + data.schedule,
        schedule: data.schedule,
      }).then((res) => { });
    },

    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.goodsId || "",
        goodsId: this.$route.query.goodsId || "",
        relevanceId: this.$route.query.goodsId || "",
        resource: this.$route.query.resource || "distribute",
        resourceType: this.$route.query.resourceType || "goods",
        teachInstId: this.$route.query.teachInstId || "",
      }).then((res) => { });
    },

    // 获取阅读文件地址和文件进度
    getFileLocation() {
      selectFileLinkAndReadingLocation({
        goodsFileId: this.goodsId || "",
        goodsId: this.$route.query.goodsId || "",
        relevanceId: this.$route.query.relevanceId || "",
        resource: this.$route.query.resource || "",
        resourceType: this.$route.query.resourceType || "",
        teachInstId: this.$route.query.teachInstId || "",
      }).then((res) => {
        let l = res.data.readingLocation || ''
        let location = res.data.readingLocation || ''
        if (l.indexOf('__') != -1) {
          location = l.split('__')[0];
          this.progressData.progress = l.split('__')[1];
        }
        this.location = location
      });
    },

    // 下载资源文件
    downloadFile(e) { },
    openTestPaper(e) {
      let url = `${e.info.link}${e.info.link.indexOf("?") == -1 ? "?" : "&"}bokName=${this.textBookData.textBooksName}&showAi=${this.textBookData.showAi == 0}`
      this.$refs.xmlDigitalTeaching.openTestPaperPage(url)

    },

    // 更新阅读进度
    updateReadLocation(newLocation) {
      this.operationalState = 0;
      this.updateOcReadSchedule(newLocation); //更新阅读时长
    },
    //AI解析
    setanalysis(data) {
      this.openAiParsing({ text: data.value.replace(/&nbsp;/gi, "") });
    },

    // 打开AI解析
    openAiParsing(data) {
      if (this.textBookData.showAi == "0" && this.pageType != "pc") {
        this.$refs.xmlRobot.show = true;
        this.$refs.xmlRobot.sendingMsg(data.text);
      } else if (this.textBookData.showAi == "0" && this.pageType == "pc") {
        this.$refs.robot.robotShwo = true;
        this.$refs.robot.sending(data.text);
      }
    },

    queryData(data) {
      let bookInfo = {};

      const getItemByChild = (list, label) => {
        for (let i = 0; i < list.length; i++) {
          this.$set(list[i], "label", list[i].catalogName);
          let it = list[i];
          bookInfo[it.id] = it;
          if (it.children) {
            getItemByChild(it.children);
          }
        }
        this.looseLeafData = bookInfo;
        if (data[0].children?.length > 0) {
          for (let i = 0; i < data[0].children.length; i++) {
            this.$set(data[0].children[i], "hiddenFlag", "1");
          }
        }
        setTimeout(() => {
          this.digitalTeaching = true;
          this.catalogList = data;
        }, 500);
      };
      getItemByChild(data);
    },
  },
  destroyed() {
    clearInterval(this.setInterval2);
    this.setInterval2 = null;
  },
};
</script>

<style lang="scss">
.crtvup-text-book-reader-pc {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 700px;
  }

  .ouchn-container.preview-mode .preview-container-title-pc .container-iocn-search-pc {
    top: 15px;
  }

  .xml-single-question-group-pc {
    .shop-item-img {
      img {
        width: 100%;
      }
    }
  }

  .ouchn-container .parent-group {
    padding: 16px 50px;
  }

  // .tab-title-pc {
  //   display: none;
  // }
  .xml-single-question-group-pc {
    .group-content-box {
      .stem-box {
        display: flex;

        .question-number {
          padding-right: 4px;
          line-height: 28px;
        }
      }
    }
  }
}

.crtvup-text-book-reader-h5,
.crtvup-text-book-reader-pad {
  .xml-digital-teaching-preview {
    .parent-group {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }
}

.do-not-display-nav-bar {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 700px;
  }

  .ouchn-container .parent-group {
    padding: 16px 30px;
  }

  .preview-container-title-pc {
    display: none !important;
  }

  .pc-catalog.pc-catalog--render {
    margin-top: 0 !important;
    height: calc(100vh - 6px) !important;
  }

  .ouchn-container.preview-mode .preview-tree-box-pc.custom-catalog-tree {
    height: calc(100vh - 46px) !important;
  }

  .tab-title-pc {
    top: 0 !important;
  }

  .preview-list-counter-pc {
    margin: 0 auto 40px auto !important;
    height: calc(100vh - 46px) !important;
    padding-top: 0 !important;
  }

  .preview-list-pc {
    height: 100vh !important;
  }

  .tab-title-pc {
    display: none !important;
  }

  .add-notes-bookmarks-pc {
    display: none !important;
  }
}

.iframe {
  width: 100%;
  height: 100%;
  height: calc(100vh - 60px);
}

.xml-viewer__wrapper .phone-preview .preview-list-counter::-webkit-scrollbar {
  width: 0 !important;
}

.el-dialog-icon-arrow-left {
  position: absolute;
  left: 10px;
  top: 14px;

  .el-icon-arrow-left {
    font-size: 20px;
    cursor: pointer;
    font-weight: 600;
  }
}
</style>
